import {Output, Input, Component, OnInit } from "@angular/core";
import {EventEmitter} from "@angular/core";
import {DataService} from "src/app/services/common/data.service";
import {StripeService} from "src/app/services/common/stripe.service";
import {ShopService} from "src/app/services/common/shop.service";
import {ViewService} from "src/app/services/common/view.service";
import {TranslateService} from "@ngx-translate/core";
import {FormControl, Validators, FormGroup} from "@angular/forms";
import {ViewChild, ElementRef} from "@angular/core";

@Component({
  selector: 'app-shipping-data',
  templateUrl: './shipping-data.component.html',
  styleUrls: ['./shipping-data.component.scss'],
})
export class ShippingDataComponent implements OnInit {
  @Input() setShippingData;
  @Input() btnLabel: string;
  @Input() loaderBtn: boolean;
  @Output() addressUpdated = new EventEmitter<any>();
  public shippingAddressForm: FormGroup;
  lang: any;

  constructor(
    public data: DataService,
    public stripeService: StripeService,
    public shopService: ShopService,
    private view: ViewService,
    private translate: TranslateService,
  ) { }

  @ViewChild('int') int: ElementRef;


  ngOnInit() {
    this.shippingAddressForm = new FormGroup({
      name: new FormControl(null, {
        updateOn: 'change',
        validators: [Validators.required, Validators.minLength(2)]
      }),
      address1: new FormControl(null, {
        updateOn: 'change',
        validators: [Validators.required, Validators.minLength(2)]
      }),
      city: new FormControl(null, {
        updateOn: 'change',
        validators: [Validators.required, Validators.minLength(2)]
      }),
      zipcode: new FormControl(null, {
        updateOn: 'change',
        validators: [Validators.required, Validators.minLength(2)]
      }),
      state: new FormControl(null, {
        updateOn: 'change',
        validators: [Validators.required, Validators.minLength(2)]
      }),
      country: new FormControl(null, {
        updateOn: 'change',
        validators: [Validators.required, Validators.minLength(2)]
      }),
      phone: new FormControl(null, {
        updateOn: 'change',
        validators: [Validators.required, Validators.pattern('[- +()0-9]+')]
      }),
      id: new FormControl(null, {
        updateOn: 'change'
      })

    });
    this.translate.get(['USER_DATA', 'SHIPPING_DATA']).subscribe((lang: any) => {
      this.lang = lang;
    });
  }

  ngAfterViewInit(){
    this.int.nativeElement.scrollIntoView({behavior: 'auto'});
  }

  async saveAddress(){
    await this.view.hideLoading()
    await this.view.showLoading(this.translate.instant('FREE_TRIAL.salvataggio_indirizzo_in_corso'))
    try{
      this.addressUpdated.emit({success: true, data: this.shippingAddressForm.value})
      await this.view.hideLoading()
    }catch(err){
      await this.view.hideLoading()
    }
  }

}
